import type { ReactNode } from 'react';
import { Button, Text, makeStyles, mergeClasses, tokens } from '@coreai/fluentui-react';
import { OpenRegular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
    padding: tokens.spacingVerticalM,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusMedium,
    minWidth: 0,
  },
  icon: {
    width: '48px',
    height: '48px',
    flexShrink: 0,
    borderRadius: tokens.borderRadiusMedium,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    fontSize: tokens.fontSizeHero700,
  },
  info: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalXS, minWidth: 0 },
  name: { fontSize: tokens.fontSizeBase400, fontWeight: tokens.fontWeightSemibold, overflowWrap: 'anywhere', whiteSpace: 'normal' },
  subtitle: { fontSize: tokens.fontSizeBase200, color: tokens.colorNeutralForeground3, overflowWrap: 'anywhere', whiteSpace: 'normal' },
  documentation: { alignSelf: 'flex-start', width: 'fit-content', minWidth: 0, maxWidth: '100%', whiteSpace: 'normal', overflowWrap: 'anywhere', textAlign: 'left' },
});

interface NodeAboutCardProps {
  name: string;
  subtitle: string;
  icon: ReactNode;
  iconClassName?: string;
}

export function NodeAboutCard({ name, subtitle, icon, iconClassName }: NodeAboutCardProps) {
  const styles = useStyles();
  return (
    <div className={styles.card} data-testid="node-about-card">
      <div className={mergeClasses(styles.icon, iconClassName)} aria-hidden="true">{icon}</div>
      <div className={styles.info}>
        <Text className={styles.name}>{name}</Text>
        <Text className={styles.subtitle}>{subtitle}</Text>
      </div>
    </div>
  );
}

export function NodeAboutDocumentationLink() {
  const styles = useStyles();
  return (
    <Button as="a" className={styles.documentation} href="https://learn.microsoft.com/azure/logic-apps/"
      target="_blank" rel="noopener noreferrer" appearance="subtle" icon={<OpenRegular />}>
      View Documentation
    </Button>
  );
}
